import {defineRouting} from 'next-intl/routing';

export const routing = defineRouting({
    // A list of all locales that are supported
    locales: ['de', 'en', 'es', 'es-ar', 'es-mx', 'fr', 'pt', 'pt-br', 'ru', 'zh', 'es-cl', 'es-pe'],

    // Used when no locale matches
    defaultLocale: 'en',

    localePrefix: 'as-needed'
});
